import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Panel } from 'primereact/panel';
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Operacao } from '../../@types';
import { OperacoesService, PermissoesService } from '../../services';
import ActionButtons from './action-buttons';
import useAsyncFetch from '../../hooks/use-async';
import { convertOperacoesToList } from './utils';
import { defaultColumnProps } from '../utils';

const acoesField = (item: Operacao, onDelete: () => Promise<void>) => (
  <ActionButtons item={item} onDelete={onDelete} />
);

const OperacaoPage = () => {
  const navigate = useNavigate();
  const permissoes = PermissoesService;

  const { data: operacoes, refetch } = useAsyncFetch(
    {
      callback: async () =>
        convertOperacoesToList(await OperacoesService.list()),
      errorMessage: 'Falha ao buscar as operações.',
      withLoader: true,
    },
    [],
  );

  return (
    <div className="container w-full gerenciador-dados-create-edit-container">
      <div className="flex flex-wrap mt-6 mx-3">
        <div className="text-3xl font-normal">Operações de Campo</div>
        {permissoes.operacao.manage && (
          <Button
            className="button-secondary ml-auto"
            label="+ Novo"
            severity="success"
            onClick={() => navigate('create')}
          />
        )}
      </div>
      <div>
        <Panel className="mt-4 mx-3">
          <div className="col-12 m-auto px-4 py-0">
            <ConfirmDialog />

            <DataTable
              value={operacoes}
              emptyMessage="Nenhuma operação de campo encontrada."
              paginator
              rows={15}
              className="mt-5 p-0 data-table p-datatable-striped"
            >
              <Column
                {...defaultColumnProps('left')}
                field="descricao"
                header="Descrição"
              />
              <Column
                {...defaultColumnProps('left')}
                body={({ statusOperacao }: Operacao) =>
                  OperacoesService.STATUS_OPERACOES_HUMANIZED[statusOperacao]
                }
                field="humanizedTipo"
                header="Tipo"
              />
              {permissoes.atividade.manage && (
                <Column
                  body={(item) => acoesField(item, refetch)}
                  header=" "
                  className="col max-w-2rem"
                  align="right"
                />
              )}
            </DataTable>
          </div>
        </Panel>
      </div>
    </div>
  );
};

export default OperacaoPage;
